import { render, staticRenderFns } from "./examination.vue?vue&type=template&id=b073a5de&scoped=true"
import script from "./examination.vue?vue&type=script&lang=js"
export * from "./examination.vue?vue&type=script&lang=js"
import style0 from "./examination.vue?vue&type=style&index=0&id=b073a5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b073a5de",
  null
  
)

export default component.exports